var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  ScreenAction: () => ScreenAction,
  ScreenSummary: () => ScreenSummary
});
var import_cardGroup = __toModule(require("../card/cardGroup"));
var import_screen = __toModule(require("../screen/screen"));
var import_addMapper = __toModule(require("./forms/addMapper"));
var import_yayoyakiValidator = __toModule(require("../yayoyakiValidator"));
var import_yayoyakiValue = __toModule(require("../yayoyakiValue"));
var import_constants = __toModule(require("../constants"));
var ScreenAction;
(function(ScreenAction2) {
  ScreenAction2["DELETE_ALL_CARDS"] = "deleteAllCards";
  ScreenAction2["RESET_ALL_CARDS"] = "resetAllCards";
})(ScreenAction || (ScreenAction = {}));
class ScreenSummary extends import_screen.Screen {
  constructor(samaData, samaForm, screenName, navigationIndex) {
    super(samaData, samaForm, screenName, navigationIndex);
    this.samaData = samaData;
    this.samaForm = samaForm;
    this.screenName = screenName;
    this.navigationIndex = navigationIndex;
    this.validateScreenSummary();
  }
  validateScreenSummary() {
    if (!Array.isArray(this.screenForm.cardsId) || this.screenForm.cardsId.length === 0) {
      throw new Error("ScreenSummary: screenForm.cards should be an array with at least one element.");
    }
    if (!!this.screenForm.yayoyakiCurrentId && !this.screenForm.yayoyakiParentId || !this.screenForm.yayoyakiCurrentId && !!this.screenForm.yayoyakiParentId) {
      throw new Error("ScreenSummary: yayoyakiCurrentId and yayoyakiParentId should be both set or both unset.");
    }
  }
  isSingleCardGroup() {
    return this.getCardGroups().length === 1;
  }
  getCardGroupAdd() {
    return this.getCardGroups().find((cardGroup) => {
      return cardGroup.getEditScreenId() === this.screenForm.addScreen;
    });
  }
  getYayoyakis() {
    var _a;
    return (_a = this.screenForm.yayoyakisId) == null ? void 0 : _a.map((yayoyakiId) => {
      const yayoyakiForm = this.samaForm.getYayoyakiForm(yayoyakiId);
      return new import_yayoyakiValue.YayoyakiValue(this.samaData, this.samaForm, yayoyakiForm, this.navigationIndex || 0);
    });
  }
  getYayoyakisSiblingsId() {
    return this.getCardGroups().map((cardGroup) => cardGroup.getYayoyakisSiblingsId()).flat();
  }
  getHeaderYayoyakis() {
    if (this.getYayoyakis()) {
      return this.getYayoyakis().filter((yayoyaki) => import_constants.yayoyakiHeaderTypes.some((yayoyakiHeader) => {
        var _a;
        return ((_a = yayoyaki.getRenderForm()) == null ? void 0 : _a.type) === yayoyakiHeader;
      }));
    } else {
      return [];
    }
  }
  getBodyYayoyakis() {
    if (this.getYayoyakis()) {
      return this.getYayoyakis().filter((yayoyaki) => import_constants.yayoyakiHeaderTypes.every((yayoyakiHeader) => {
        var _a;
        return ((_a = yayoyaki.getRenderForm()) == null ? void 0 : _a.type) !== yayoyakiHeader;
      }));
    } else {
      return [];
    }
  }
  getAdd() {
    return this.screenForm.addScreen;
  }
  add() {
    if (!this.isAdd()) {
      throw new Error("ScreenSummary: add is illegal, there are multiple cardSummaries and no custom add screen.");
    }
    if (this.isSingleCardGroup()) {
      return this.getCardGroups()[0].add(this.navigationIndex);
    }
    if (this.getCardGroupAdd()) {
      return this.getCardGroupAdd().add(this.navigationIndex);
    }
    if (this.getAdd()) {
      return { id: this.getAdd() };
    }
    throw new Error(`ScreenSummary: You can't add screen because there is no CardGroupAdd and/or Add Screen in ScreenForm.`);
  }
  getCardGroups() {
    return this.screenForm.cardsId.map((cardId) => {
      const cardGroup = this.samaForm.getCardForm(cardId);
      return new import_cardGroup.CardGroup(this.samaData, this.samaForm, cardGroup, this.screenForm.addScreen, this.getFilter());
    });
  }
  getInitialLengthCardsGroups() {
    return this.screenForm.cardsId.reduce((acc, cardId) => {
      const cardGroup = this.samaForm.getCardForm(cardId);
      const yayoyakiMap = this.samaForm.getYayoyakiMap();
      const matrixGroupYayoyakiId = cardGroup.yayoyakiSiblingsId.find((yayoyakiId) => {
        var _a;
        return (_a = yayoyakiMap[yayoyakiId]) == null ? void 0 : _a.isMatrixGroupIdentifier;
      });
      if (!matrixGroupYayoyakiId) {
        return __spreadProps(__spreadValues({}, acc), { [cardId]: 0 });
      }
      const valueIdentifier = this.samaData.getUserDataInitial()[matrixGroupYayoyakiId];
      if (Array.isArray(valueIdentifier)) {
        return __spreadProps(__spreadValues({}, acc), { [cardId]: valueIdentifier.length });
      }
      return __spreadProps(__spreadValues({}, acc), { [cardId]: 0 });
    }, {});
  }
  hasAtLeastOneCard() {
    return this.getCardGroups().some((cardGroup) => cardGroup.list().length > 0);
  }
  isAdd() {
    if (this.isSingleCardGroup()) {
      return true;
    }
    if (this.getCardGroupAdd()) {
      return true;
    }
    return import_addMapper.AddMapper.isSummaryAdd(this.screenName);
  }
  isDataValid() {
    const isValid = this.getCardGroups().every((cardGroup) => {
      return cardGroup.list().every((card) => card.isValid());
    });
    if (isValid) {
      return super.isDataValid();
    }
    return isValid;
  }
  isPendingReview() {
    return this.getCardGroups().filter((cardGroup) => cardGroup.isPendingReview()).length > 0;
  }
  isAddEnabled() {
    if (this.screenForm.addScreenRequirement) {
      return !!import_yayoyakiValidator.YayoyakiValidator.validateRequirementsSafe(this.samaData.getUserData(), this.screenForm.addScreenRequirement, this.navigationIndex);
    }
    return true;
  }
  isDeleteAllCardsAllowed() {
    var _a;
    return Boolean((_a = this.screenForm.actions) == null ? void 0 : _a.includes(ScreenAction.DELETE_ALL_CARDS.toString()));
  }
  isResetAllCardsAllowed() {
    var _a;
    return Boolean((_a = this.screenForm.actions) == null ? void 0 : _a.includes(ScreenAction.RESET_ALL_CARDS.toString()));
  }
  deleteAllCards() {
    this.getCardGroups().forEach((cardGroup) => {
      cardGroup.deleteAll();
    });
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ScreenAction,
  ScreenSummary
});
